var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"image-preview",attrs:{"src":_vm.showImage}})])
}
var staticRenderFns = []

export { render, staticRenderFns }